import {getImage} from '@/constants';
import MainContent from '@/Layouts/MainContent';
import {Link} from '@inertiajs/react';

export default function () {
    return (
        <MainContent title="Not Found">
            <div className="flex flex-col w-full justify-start items-center gap-y-8 mb-12 xl:mb-20">
                <div className="w-2/3">
                    <img
                        src={getImage('not_found.png')}
                        className="w-full h-auto object-cover"
                    />
                </div>
                <h2 className="text-4xl font-semibold tracking-tight text-pretty text-prime-600 sm:text-5xl">
                    Page Not Found
                </h2>
                <p className="text-gray-600">
                    Sorry, we couldn’t find the page you’re looking for.
                </p>
                <Link
                    href={route('frontend.home')}
                    className={'btn-default px-8'}
                >
                    back to home
                </Link>
            </div>
        </MainContent>
    );
}
